import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n, { loadLanguageAsync } from './i18n'
import { errorHandlerPlugin } from './plugins/errorHandler'
import './assets/tailwind.css'
import './styles/index.css'
// TODO: Consider adopting a "Root Path Only" approach in the future, which would
// eliminate the need for asset path fixing. This would involve:
// 1. Deploying the application exclusively at the root path ('/')
// 2. Removing the assetPathFix.ts utility
// 3. Simplifying the server-side routing
// See the Lambda asset loading guide documentation for more details.
import { applyAssetPathFixes, fixCssLinks } from './utils/assetPathFix'

// Apply all asset path fixes in one call
applyAssetPathFixes()

// Fix CSS links after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  fixCssLinks()

  // Apply asset path fixes again after DOM is loaded
  // This catches any dynamically added elements
  applyAssetPathFixes()
})

// Prevent double-tap zoom on iOS Safari
//This is a lightweight solution that still allows pinch-zoom for accessibility
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (event) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });
}

// Create the app instance
const app = createApp(App)

// Use plugins
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(errorHandlerPlugin)

// Wait for language to load before mounting the app
loadLanguageAsync('en')
  .then(() => {
    // Mount the app
    app.mount('#app')
  })
  .catch(error => {
    console.error('Failed to load language:', error)
    // Mount the app anyway to avoid blank screen
    app.mount('#app')
  })